import { c as _c } from "react/compiler-runtime";
// Celebration OG shell variant. Brand-blue halftone raster with centered
// wordmark. For gift, rank podium, resolution-winner.

import type { ReactNode } from 'react';
import { OG_DIMENSIONS, OG_TOKENS } from '../../tokens';
import { OgDemoModeBadge } from '../chrome/og-demo-mode-badge';
import { OgHeaderChrome } from '../chrome/og-header-chrome';
import { OgShellBackground } from '../chrome/og-shell-background';
import { OgShellSlot } from '../chrome/og-shell-slot';
import { SHELL_METRICS } from '../shell-tokens';
interface VariantProps {
  children: ReactNode;
  eyebrow?: string | null;
  demoMode?: boolean;
  /** Overrides `SHELL_METRICS.celebration.contentGap`. */
  contentGap?: number;
}
export function ShellCelebration(props) {
  const $ = _c(14);
  const m = SHELL_METRICS.celebration;
  const contentGap = props.contentGap ?? m.contentGap;
  let t0;
  if ($[0] !== contentGap) {
    t0 = {
      width: OG_DIMENSIONS.width,
      height: OG_DIMENSIONS.height,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      padding: m.inset,
      gap: contentGap,
      color: OG_TOKENS.gray50,
      fontFamily: "Geist, var(--font-geist-sans), system-ui, sans-serif",
      overflow: "hidden"
    };
    $[0] = contentGap;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <OgShellBackground variant="celebration" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = props.eyebrow ?? m.eyebrow;
  let t3;
  if ($[3] !== t2) {
    t3 = <OgHeaderChrome layout={m.headerLayout} logoSize={m.logoSize} eyebrow={t2} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.children) {
    t4 = <OgShellSlot padding={m.slotPadding}>{props.children}</OgShellSlot>;
    $[5] = props.children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.demoMode) {
    t5 = props.demoMode === true && <OgDemoModeBadge />;
    $[7] = props.demoMode;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t0 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div style={t0}>{t1}{t3}{t4}{t5}</div>;
    $[9] = t0;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}